import React from 'react';
import Slider from "react-slick";
import { Picture } from '../picture';

import ArrowLeft from './arrow-left.inline.svg';
import ArrowRight from './arrow-right.inline.svg';

const sliderSettings = {
  dots: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true
};

export class Gallery extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  left = () => {
    this.refs.slider.slickPrev();
  }

  right = () => {
    this.refs.slider.slickNext();
  }

  render () {
    return (
      <div className="gallery">
        <Slider {...sliderSettings} ref="slider">
          { this.props.images.map(photo => <Picture key={photo.id} image={photo} src={photo.file.url + '?h=800'} />)  }
        </Slider>
        <div className="gallery__arrows">
          <div className="gallery__arrows__arrow gallery__arrows__arrow--left" onClick={this.left}>
            <ArrowLeft />
          </div>
          <div className="gallery__arrows__arrow gallery__arrows__arrow--right" onClick={this.right}>
            <ArrowRight />    
          </div>
        </div>
      </div>
    );
  }
}
